export default __webpack_public_path__ + "public/images/services/Activity@2x.png?90aa58e2";